import React, { memo, useState } from 'react';
import Sidebar from 'react-sidebar';
import Content from './Content';
import { ReactComponent as ShoppingCart } from 'assets/icons/shopping_cart.svg';
import { variables } from 'components/theme';
import { useStateValue } from 'context/store';
import { openCart, closeCart } from 'context/cart/actions';
import { CartNumber, CartButton } from './elements';
import { useTheme } from 'context/theme/themeContext';
import { useWindowSize } from 'utils/hooks';

const mql = window.matchMedia(`(max-width: 768px)`);

function Cart() {
  const {
    state: { cart },
    dispatch
  } = useStateValue();

  const { width } = useWindowSize();

  const { themeMode } = useTheme();

  const { cartIsOpen, items } = cart;

  const [responsive, setResponsive] = useState({
    width: mql.matches ? '100%' : '673px',
    padding: mql.matches ? '21px 21px 0' : '21px 42px 0'
  });

  mql.onchange = ({ matches }) =>
    setResponsive({
      width: matches ? '100%' : '673px',
      padding: matches ? '21px 21px 0' : '21px 42px 0'
    });

  const style = {
    root: {
      position: 'static',
      overflow: 'initial',
      display: 'flex',
      alignItems: 'center',
      zIndex: 6
    },
    sidebar: {
      width: responsive.width,
      position: 'fixed',
      overflow: 'auto',
      bottom: 0,
      right: 0,
      padding: responsive.padding,
      borderLeft: '1px solid #fff',
      background:
        themeMode === 'light' ? variables.colors.white : variables.colors.black
    },
    content: {
      position: 'static'
    }
  };
  return (
    <Sidebar
      sidebar={<Content />}
      open={cartIsOpen}
      onSetOpen={() => dispatch(closeCart())}
      pullRight={true}
      styles={style}
    >
      {width > 768 && (
        <CartButton onClick={() => dispatch(openCart())}>
          <ShoppingCart fill={themeMode === 'dark' && '#fff'} />
          <CartNumber>{items.length}</CartNumber>
        </CartButton>
      )}
    </Sidebar>
  );
}

export default memo(Cart);
